/* Maison Vivelle — eigen cart drawer (vervangt UpCart). */
(function () {
  if (customElements.get('cart-drawer')) return;

  var SECTION = 'mv-cart-drawer';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TIMER_KEY = 'mvCartTimerEnd';

  function isCartPath(pathname) {
    return /\/cart\/?$/.test(pathname);
  }

  class MvCartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.mv-cart__panel');
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
      this.initTimer();
      this.bindGlobal();
    }

    /* Contract dat Vitals (en Dawn-achtige scripts) gebruiken. */
    getSectionsToRender() {
      return [{ id: SECTION }];
    }
    setActiveElement(el) {
      this.lastFocus = el;
    }
    renderContents(json) {
      if (json && json.sections && json.sections[SECTION]) {
        this.applyHTML(json.sections[SECTION]);
      } else {
        this.refresh();
      }
      this.open();
    }

    isOpen() {
      return this.classList.contains('is-open');
    }
    open() {
      if (this.isOpen()) return;
      if (!this.lastFocus) this.lastFocus = document.activeElement;
      if (this.tickTimer) this.tickTimer();
      this.classList.add('is-open');
      document.documentElement.classList.add('mv-cart-lock');
      var panel = this.panel;
      setTimeout(function () { panel && panel.focus({ preventScroll: true }); }, 50);
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('mv-cart-lock');
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
      this.lastFocus = null;
    }

    onClick(e) {
      var closeEl = e.target.closest('[data-mv-close]');
      if (closeEl) {
        e.preventDefault();
        this.close();
        return;
      }
      var qtyEl = e.target.closest('[data-mv-qty]');
      if (qtyEl) {
        e.preventDefault();
        this.change(qtyEl.dataset.key, parseInt(qtyEl.dataset.mvQty, 10) || 0);
      }
    }

    applyHTML(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('MvCartContents');
      var current = this.querySelector('#MvCartContents');
      if (!fresh || !current) return;
      current.innerHTML = fresh.innerHTML;
      current.dataset.count = fresh.dataset.count || '0';
      this.updateBubble(parseInt(current.dataset.count, 10) || 0);
    }

    updateBubble(count) {
      document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
        b.classList.toggle('cart-link__bubble--visible', count > 0);
      });
    }

    showError(message) {
      var el = this.querySelector('[data-mv-error]');
      if (!el || !message) return;
      el.textContent = message;
      el.hidden = false;
    }

    refresh() {
      return fetch(ROOT + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((json) => { if (json && json[SECTION]) this.applyHTML(json[SECTION]); })
        .catch(function () {});
    }

    change(key, quantity) {
      if (!key) return;
      this.classList.add('is-busy');
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION, sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then((res) => {
          if (res.ok && res.json.sections && res.json.sections[SECTION]) {
            this.applyHTML(res.json.sections[SECTION]);
          } else {
            return this.refresh().then(() => {
              this.showError(res.json && (res.json.description || res.json.message));
            });
          }
        })
        .catch(() => this.refresh())
        .finally(() => this.classList.remove('is-busy'));
    }

    addForm(form) {
      var data = new FormData(form);
      data.append('sections', SECTION);
      data.append('sections_url', location.pathname);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then((res) => {
          if (!res.ok || res.json.status) {
            window.alert((res.json && (res.json.description || res.json.message)) || 'Erreur');
            return;
          }
          this.lastFocus = btn || document.activeElement;
          this.renderContents(res.json);
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }

    bindGlobal() {
      var self = this;

      /* Klik op het winkelwagen-icoon of een /cart-link: tiroir openen i.p.v. de pagina. */
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || a.closest('cart-drawer')) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        var url;
        try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.origin !== location.origin || !isCartPath(url.pathname)) return;
        if (isCartPath(location.pathname)) return;
        e.preventDefault();
        e.stopPropagation();
        self.lastFocus = a;
        self.open();
        self.refresh();
      }, true);

      /* Gewone productformulieren (buiten Vitals) via AJAX toevoegen. */
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add/.test(action)) return;
        if (form.closest('vtls-product-info')) return;
        e.preventDefault();
        e.stopPropagation();
        self.addForm(form);
      }, true);

      /* Andere scripts die zelf /cart/add aanroepen: tiroir verversen en openen. */
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var promise = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
          var body = init && init.body;
          var ours = body instanceof FormData && String(body.get('sections') || '').indexOf(SECTION) > -1;
          if (!ours && typeof body === 'string' && body.indexOf(SECTION) > -1) ours = true;
          if (isAdd && !ours) {
            promise.then(function (r) {
              if (r.ok) self.refresh().then(function () { self.open(); });
            }).catch(function () {});
          }
        } catch (err) {}
        return promise;
      };

      /* Terug-knop (bfcache): inhoud actueel houden. */
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
    }

    initTimer() {
      var el = this.querySelector('[data-mv-timer]');
      if (!el) return;
      var minutes = parseInt(this.dataset.timerMinutes, 10) || 10;
      var end = 0;
      try { end = parseInt(sessionStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) {}
      var reset = function () {
        end = Date.now() + minutes * 60000;
        try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
      };
      if (!end || end <= Date.now() || end - Date.now() > minutes * 60000) reset();
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { reset(); left = end - Date.now(); }
        var s = Math.ceil(left / 1000);
        el.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      };
      /* Alleen tikken als de cart open is: geen werk op de achtergrond. */
      this.tickTimer = tick;
      tick();
      setInterval(() => { if (this.isOpen()) tick(); }, 1000);
    }
  }

  customElements.define('cart-drawer', MvCartDrawer);
})();
